import type {
	FieldValidationInput,
	ValidationError,
} from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/types/validation.tsx';
import { POSITION_FIELD_DESCRIPTION_INPUT } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/utils/validation/constants.tsx';
import { fieldValidationMessages } from './messages.tsx';

const valid: ReadonlyArray<ValidationError> = [];

const FIELD_ALIAS_DESCRIPTION_MAX_LENGTH = 255;
const errorAliasDescriptionTooLong: ReadonlyArray<ValidationError> = [
	{
		position: POSITION_FIELD_DESCRIPTION_INPUT,
		messageDescriptor: fieldValidationMessages.errorFieldDescriptionTooLong,
		values: {
			maxCharacters: FIELD_ALIAS_DESCRIPTION_MAX_LENGTH,
		},
	},
];

export const fieldAliasDescriptionMustBeShortEnough = ({
	field,
}: FieldValidationInput): ReadonlyArray<ValidationError> => {
	if (
		// @ts-expect-error - TS2339 - Property 'alternateDescription' does not exist on type 'Field | AssociatedField'.
		field.alternateDescription != null &&
		// @ts-expect-error - TS2339 - Property 'alternateDescription' does not exist on type 'Field | AssociatedField'.
		field.alternateDescription.length > FIELD_ALIAS_DESCRIPTION_MAX_LENGTH
	) {
		return errorAliasDescriptionTooLong;
	}
	return valid;
};
